<template>
  <div class="w-full h-full">
    <l-map :zoom="zoom" :center="center" ref="map" :options="options">
      <l-tilelayer :url="url"></l-tilelayer>
      <l-marker :lat-lng="marker">
        <l-popup :content="popupContent"></l-popup>
      </l-marker>
    </l-map>
  </div>
</template>

<!--
$event.target.openPopup()
  TODO:
  Finish mobile styles.
 -->

<script>
  import Vue2Leaflet from 'vue2-leaflet'
  require('@leaflet/leaflet.css')

  export default {
    components: {
      'l-map':  Vue2Leaflet.LMap,
      'l-tilelayer':  Vue2Leaflet.LTileLayer,
      'l-marker': Vue2Leaflet.LMarker,
      'l-popup': Vue2Leaflet.LPopup,
    },
    props: ['location'],
    data() {
      return {
        zoom: 15,
        center: [Number(this.location.lat), Number(this.location.lon)],
        marker: L.latLng(Number(this.location.lat), Number(this.location.lon)),
        url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
        options: {
          sleep: true,
          attributionControl: false,
          inertia: false
        }
      }
    },
    computed: {
      popupContent() {
        let popup = '<strong class="block text-black">' + this.location.name + '</strong>'
        popup += '<span class="block my-px text-grey-darker">'
        popup += this.location.address_number ? this.location.address_street + ', ' + this.location.address_number : this.location.address_street
        popup += '</span>'
        popup += '<span class="block my-px text-grey-darker">' + this.location.phone + '</span>'
        return popup
      }
    }
  }
</script>

<style>
  .vue2leaflet-map {
    z-index: 1;
  }
</style>
